/**
 * Composable centralizado para navegação externa (nova aba do navegador).
 *
 * Centraliza a construção de URLs de navegação para o dashboard,
 * evitando repetição de strings URL hardcoded nos componentes.
 *
 * Uso:
 *   import { useNavegacao } from '@/composables/useNavegacao'
 *   useNavegacao().abrirRegra('PRODUTOS_FORNECEDOR', 'adicionar')
 *   useNavegacao().abrirComSession('minhaChave', { modulo: 'Exemplo' })
 */
export function useNavegacao () {
  const baseUrl = window.location.origin + '/dashboard'

  /**
   * Abre uma tela do sistema em nova aba usando a chave da RegraAcesso.
   * O MainDashboard lê ?regra=CHAVE e resolve a tela de abertura via useMenuBackend.
   *
   * @param {string} chaveRegra - Chave da RegraAcesso (ex: "PRODUTOS_FORNECEDOR")
   * @param {string|null} acao - Opcional: "adicionar" para abrir o formulário de criação
   */
  function abrirRegra (chaveRegra, acao = null) {
    let url = `${baseUrl}?regra=${encodeURIComponent(chaveRegra)}`
    if (acao) {
      url += `&acao=${encodeURIComponent(acao)}`
    }
    window.open(url, '_blank')
  }

  /**
   * Abre o dashboard em nova aba com dados armazenados em sessionStorage.
   * Útil para padrões como BellPendencias e SugestaoMelhoriaChatModal,
   * que precisam passar estado para a nova aba.
   *
   * @param {string} storageKey - Chave do sessionStorage
   * @param {object|string} storageValue - Valor a ser armazenado (serializado em JSON)
   */
  function abrirComSession (storageKey, storageValue) {
    sessionStorage.setItem(storageKey, JSON.stringify(storageValue))
    window.open(baseUrl, '_blank')
  }

  return {
    abrirRegra,
    abrirComSession
  }
}
